// src/pages/TourRouter.jsx
import { useParams, Navigate } from "react-router-dom";
import SanJuanTour from "./SanJuanTour";
import SanJuanTourEs from "./SanJuanTourEs";
import MexicoCityTour from "./MexicoCityTour";
import ChicagoTour from "./ChicagoTour";
import LanguageSelector, { getSavedLanguage } from "../components/LanguageSelector";

/**
 * Router component that renders the appropriate tour based on tourId
 */
export default function TourRouter() {
  const { tourId } = useParams();

  // Route to appropriate tour component
  switch (tourId) {
    case "san-juan-cofresi-treasure": {
      // Check if user has a saved language preference
      const savedLang = getSavedLanguage();
      if (savedLang === "es") {
        // Redirect to Spanish version
        return <Navigate to="/tour/san-juan-cofresi-treasure-es" replace />;
      }
      if (savedLang === "en") {
        // User chose English, show the tour
        return <SanJuanTour />;
      }
      // No preference saved - show language selector
      return <LanguageSelector baseTourId="san-juan-cofresi-treasure" />;
    }

    case "san-juan-cofresi-treasure-es":
      return <SanJuanTourEs />;

    case "mexico-city-artifact-protocol":
      return <MexicoCityTour />;

    case "chicago":
      return <ChicagoTour />;

    default:
      // Unknown tour ID - redirect to tours page
      return <Navigate to="/tours" replace />;
  }
}
